import { omit } from 'lodash'

import { CACHE_IMAGE, CACHE_ALL_IMAGES, PURGE_IMAGE } from '../constants/ActionTypes'

/**
 * @typedef {import('../types/system').ImageCache} ImageCache
 * @typedef {import('../index').PltrAction} PltrAction
 */

/**
 * @type {ImageCache | Null}
 */
const INITIAL_STATE = null

/**
 * @param {ImageCache | Null} state
 * @param {PltrAction} action
 * @return {ImageCache | Null}
 */
const imageCacheReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CACHE_IMAGE: {
      const initialisedCache = state ?? {}
      return {
        ...initialisedCache,
        [action.storageUrl]: {
          publicUrl: action.publicUrl,
          timestamp: action.timestamp,
        },
      }
    }
    case CACHE_ALL_IMAGES: {
      const initialisedCache = state ?? {}
      return Object.entries(action.cache).reduce((acc, next) => {
        const [storageUrl, publicUrl] = next
        if (!acc[storageUrl]) {
          return {
            ...acc,
            [storageUrl]: {
              publicUrl,
              timestamp: action.timestamp,
            },
          }
        } else {
          return acc
        }
      }, initialisedCache)
    }
    case PURGE_IMAGE: {
      if (state) {
        return omit(state, action.storageUrl)
      } else {
        return state
      }
    }
    default: {
      return state
    }
  }
}

export default imageCacheReducer
